import anatomieHero from "../../images/portfolio/banners/anatomie.webp";
import frankHero from "../../images/portfolio/banners/frank-hero.webp";
import opennHero from "../../images/portfolio/banners/openn.webp";
import rxntHero from "../../images/portfolio/banners/rxnt-hero.webp";
import svhsHero from "../../images/portfolio/banners/svhs-hero.webp";
import tdsHero from "../../images/portfolio/banners/tds.webp";
import tynaxHero from "../../images/portfolio/banners/tynax.webp";
import vacsewcenterHero from "../../images/portfolio/banners/vacsewcenter.webp";
import wbesHero from "../../images/portfolio/banners/wbes.webp";
import willshipHero from "../../images/portfolio/banners/willship.webp";

import anatomieMockup from "../../images/portfolio/anatomie-mockup.webp";
import frankMockup from "../../images/portfolio/frank-mockup.webp";
import opennMockup from "../../images/portfolio/openn-mockup.webp";
import rxntMockup from "../../images/portfolio/rxnt-mockup.webp";
import svhsMockup from "../../images/portfolio/svhs-mockup.webp";
import tdsMockup from "../../images/portfolio/tds-mockup.webp";
import tynaxMockup from "../../images/portfolio/tynax-mockup.webp";
import vacsewcenterMockup from "../../images/portfolio/vacsewcenter-mockup.webp";
import wbesMockup from "../../images/portfolio/wbes-mockup.webp";
import willshipMockup from "../../images/portfolio/willship-mockup.webp";

import anatomieTechnology from "../../images/portfolio/anatomie/anatomie.webp";
import frankTechnology from "../../images/portfolio/frank/frank.webp";
import opennTechnology from "../../images/portfolio/openn/openn.webp";
import rxntTechnology from "../../images/portfolio/rxnt/rxnt-technology.webp";
import svhsTechnology from "../../images/portfolio/svhs/svhs.webp";
import tdsTechnology from "../../images/portfolio/tds/tds.webp";
import tynaxTechnology from "../../images/portfolio/tynax/tynax.webp";
import vacsewcenterTechnology from "../../images/portfolio/vacsewcenter/vacsewcenter.webp";
import wbesTechnology from "../../images/portfolio/wbes/wbes.webp";
import willshipTechnology from "../../images/portfolio/willship/willship.webp";


export const portfolioImages = {
  hero: {
    anatomie: anatomieHero,
    frank: frankHero,
    openn: opennHero,
    rxnt: rxntHero,
    svhs: svhsHero,
    tds: tdsHero,
    tynax: tynaxHero,
    vacsewcenter: vacsewcenterHero,
    wbes: wbesHero,
    willship: willshipHero,
  },
  mockup: {
    anatomie: anatomieMockup,
    frank: frankMockup,
    openn: opennMockup,
    rxnt: rxntMockup,
    svhs: svhsMockup,
    tds: tdsMockup,
    tynax: tynaxMockup,
    vacsewcenter: vacsewcenterMockup,
    wbes: wbesMockup,
    willship: willshipMockup,
  },
  technology: {
    anatomie: anatomieTechnology,
    frank: frankTechnology,
    openn: opennTechnology,
    rxnt: rxntTechnology,
    svhs: svhsTechnology,
    tds: tdsTechnology,
    tynax: tynaxTechnology,
    vacsewcenter: vacsewcenterTechnology,
    wbes: wbesTechnology,
    willship: willshipTechnology,
  },
};
